export const booleanToString = (booleanValue: boolean | null | undefined) =>
  booleanValue === true
    ? "Yes"
    : booleanValue === false
    ? "No"
    : "No data available";
